<div class="ai-drawer py-3 px-6 h-100 madar--v2">
  <div class="flex justify-space-between align-center">
    <h3 class="ai-drawer__title">
      Ask AI
      <span class="small">(Beta Version)</span>
    </h3>
    <button mat-icon-button class="btn--xsmall text-400" type="button" (click)="closeDrawer()">
      <app-icon class="icon" size="lg" name="outline-close-circle"></app-icon>
    </button>
  </div>
  <mat-divider class="mb-3"></mat-divider>

  <div class="ai-drawer__content py-3 px-6 flex column h-92 justify-space-between">
    <div class="overflow-y-auto scrollable scrollable--y text-black" #messagesContainer>
      <div class="d-flex mb-6 align-flex-start message-container">
        <app-icon class="icon" size="md" [name]="'madar-ai-circle'"></app-icon>

        <div class="flex column ml-3">
          <p class="name m-0 weight-bold h-6">{{ 'MADAR AI'}}</p>
          <p class="message mx-0 mb-0 mt-2 weight-normal h-6">
            Hi, I'm MADAR AI.
            <br />
            What can I help with?
          </p>
        </div>
      </div>
      <div class="flex column mb-6" *ngFor="let message of messages">
        <div class="d-flex align-flex-start message-container w-100">
          <app-icon class="icon" size="md" [name]="message.author ===AiMessageAuthor.User ? 'you-avatar':'madar-ai-circle'"></app-icon>

          <div class="flex column ml-3 w-100">
            <p class="name m-0 weight-bold h-6">{{message.author ===AiMessageAuthor.User ? 'You' : 'MADAR AI'}}</p>
            <!-- Loading skeleton -->
            <ng-container *ngIf="message.isLoading; else realContent">
              <div class="message-skeleton flex column mt-2 gaps-1">
                <div class="line radius-1"></div>
                <div class="line short radius-1"></div>
              </div>
            </ng-container>

            <ng-template #realContent>
              <p class="message mx-0 mb-0 mt-2 weight-normal h-6" [innerHTML]="message.content | markdownBold"></p>
            </ng-template>
          </div>
        </div>

        <div *ngIf="message.table && message.author ===AiMessageAuthor.Bot" class="table scrollable scrollable--x overflow-y-hidden my-4">
          <table mat-table [dataSource]="message.table.dataSource" class="table">
            <ng-container *ngFor="let column of message.table.columns" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef>{{ column | removeUnderscore | titlecase }}</th>

              <td mat-cell *matCellDef="let element">{{ element[column] | removeUnderscore | titlecase }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="message.table.columns"></tr>
            <tr mat-row *matRowDef="let row; columns: message.table.columns"></tr>
          </table>
        </div>
      </div>
    </div>

    <div class="flex column">
      <app-row class="chat-input py-1 pl-3 pr-0 mt-6 align-center">
        <app-col cols="10" class="flex align-center">
          <textarea
            [(ngModel)]="message"
            (keydown.enter)="sendMessage($event)"
            appAutoGrowHeight
            #messageInput
            class="w-100 pr-3 weight-normal scrollable--y scrollable overflow-x-hidden"
            placeholder="Message MADAR AI..."
            rows="1"
          ></textarea>
        </app-col>
        <app-col cols="2">
          <button [disabled]="!message.trim() || isSending " mat-icon-button color="primary" (click)="sendMessage()">
            <app-icon class="icon" size="lg" name="arrow-up"></app-icon>
          </button>
        </app-col>
      </app-row>

      <small class="hint text-center mt-3">
        MADAR AI
        <span class="small">(Beta Version)</span>
        can make mistakes. Consider checking important information.
      </small>
    </div>
  </div>
</div>
